import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc1c64b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-menu-mobile" }
const _hoisted_2 = { class: "content-footer" }

import { ref, onMounted } from 'vue';
import TopPanelUserMenu from '@/components/TopPanelUserMenu.vue';
import TopMenuCompanySelect from '@/components/TopMenuCompanySelect.vue';
import BackToAdminButton from '@/components/BackToAdminButton.vue';
import useCompanySelect from '@/AppCompanySelect';
import useCabinetStore from '@/store/CabinetStore';
import SideMenu from './SideMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenuMobile',
  emits: ['close'],
  setup(__props, { emit }) {

const ANIMATION_TIMEOUT = 300;

const close = () => {
  closeMenu();
  setTimeout(() => emit('close'), ANIMATION_TIMEOUT);
};

const isMenuVisible = ref(false);
const openMenu = () => (isMenuVisible.value = true);
const closeMenu = () => (isMenuVisible.value = false);

onMounted(() => {
  setTimeout(() => openMenu(), ANIMATION_TIMEOUT);
});

const { isDepartment, isBackToAdminAvailable } = useCabinetStore();
const companySelectStore = useCompanySelect();

const { selectedCompanyId, isSelectCompanyAvailable } = companySelectStore;
const selectCompany = (companyId: string) => companySelectStore.selectCompany(companyId) && close();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["content", { visible: isMenuVisible.value }])
    }, [
      _createVNode(SideMenu, {
        class: "content-menu",
        isButtonCloseVisible: true,
        onClose: close
      }),
      _createElementVNode("div", _hoisted_2, [
        (_unref(isBackToAdminAvailable))
          ? (_openBlock(), _createBlock(BackToAdminButton, {
              key: 0,
              isTextShort: true,
              onSubmit: close
            }))
          : _createCommentVNode("", true),
        (_unref(isSelectCompanyAvailable))
          ? (_openBlock(), _createBlock(TopMenuCompanySelect, {
              key: 1,
              class: "mt-6",
              selectedItemId: _unref(selectedCompanyId),
              isSelectedCompanyNumberVisible: !_unref(isDepartment),
              expandToTop: true,
              onSelect: selectCompany
            }, null, 8, ["selectedItemId", "isSelectedCompanyNumberVisible"]))
          : _createCommentVNode("", true),
        _createVNode(TopPanelUserMenu, { class: "mt-6" })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["background-overlay", { visible: isMenuVisible.value }]),
      onClick: close
    }, null, 2)
  ]))
}
}

})